import { Api } from './ServerApi';
export * from './ServerApi';

export const api = new Api({ baseApiParams: { format: 'json' } });
